import {Box} from "@mui/material";
import {c} from "../landingTokens";

/**
 * Framed product screenshot. Same rounded/bordered shell as <ImagePlaceholder>,
 * so sections can swap one for the other without layout shift.
 */
export const ProductShot = ({src, alt, ratio = "16 / 10"}) => (
  <Box
    sx={{
      border: `1px solid ${c.line}`,
      borderRadius: "24px",
      overflow: "hidden",
      bgcolor: c.white,
      boxShadow: "0 30px 60px -40px rgba(92,107,232,0.3)",
    }}
  >
    <Box
      component="img"
      src={src}
      alt={alt}
      loading="lazy"
      sx={{display: "block", width: "100%", aspectRatio: ratio, objectFit: "cover", objectPosition: "top"}}
    />
  </Box>
);
